export default __webpack_public_path__ + "static/media/qr.5408154c.svg";